var title = process.env.VUE_APP_TITLE;
var isDemi = process.env.VUE_APP_IS_DEMI === 'true';
import logoHider from '@/assets/logohider.png';
import logoOpen from '@/assets/logoopen.png';
import logo from '@/assets/logo.png';
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      isDemi: isDemi,
      title: title,
      logoHider: logoHider,
      logoOpen: logoOpen,
      logo: logo
    };
  }
};